import { defaultConfig } from '~/modules/core/defaultConfig';
import { getLocaleSettings } from '~/modules/core/helpers/getLocaleSettings';
export const mapConfigToSetupObject = ({ app, moduleOptions, additionalProperties = {} }) => ({
    ...defaultConfig,
    ...moduleOptions,
    ...additionalProperties,
    ...getLocaleSettings(app, moduleOptions, additionalProperties),
});
